(() => {
  'use strict';
  if (window.__SQ_FUNCTIONAL_POLISH_V3__) return;
  window.__SQ_FUNCTIONAL_POLISH_V3__ = true;

  const PARTNER_URL = 'https://sereinqueen.store/pages/partner-with-us';
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const normalizePartnerFooter = (scope = document) => {
    scope.querySelectorAll?.('.sq-partner-footer__button').forEach((link) => { link.href = PARTNER_URL; });
  };

  const panelKey = (panel) => {
    const summary = panel.matches('details') ? panel.querySelector('summary') : null;
    const text = normalize(summary?.textContent || panel.getAttribute('aria-label') || panel.textContent);
    if (text.includes('availability')) return 'availability';
    if (text.includes('price')) return 'price';
    if (text.includes('color') || text.includes('colour')) return 'color';
    if (text.includes('size')) return 'size';
    if (text.includes('view')) return 'view';
    return '';
  };

  const normalizeFilterForm = (form) => {
    if (!(form instanceof HTMLElement)) return;
    const view = form.querySelector('.premium-view-panel, [data-premium-view-panel], [data-sq-filter-key="view"]');
    if (view) {
      view.dataset.sqFilterKey = 'view';
      view.hidden = false;
      view.removeAttribute('aria-hidden');
    }
    const panels = [...form.querySelectorAll('details, .premium-filter-accordion, .premium-mobile-filter-drawer__section')];
    let availability = null;
    panels.forEach((panel) => {
      const key = panel.dataset.sqFilterKey || panelKey(panel);
      if (!key) return;
      panel.dataset.sqFilterKey = key;
      panel.dataset.sqFilterKind = key;
      if (key === 'availability' && !availability) availability = panel;
    });
    const sortEntries = [];
    [...form.querySelectorAll('select[name="sort_by"], select[name="sort_by[]"], .premium-sort-select')].forEach((select) => {
      const block = select.closest('.premium-mobile-sort-menu, .premium-sort-menu, .premium-sort-form, .premium-mobile-filter-drawer__section') || select.parentElement;
      if (!block || block === form || sortEntries.some((entry) => entry.block === block)) return;
      sortEntries.push({ select, block });
    });
    const primarySort = sortEntries.find(({ block }) => !block.hidden && block.getAttribute('aria-hidden') !== 'true') || sortEntries[0];
    sortEntries.forEach((entry) => { if (primarySort && entry.block !== primarySort.block) entry.block.remove(); });
    if (primarySort) {
      const { select: sortSelect, block: sortBlock } = primarySort;
      sortBlock.dataset.sqFilterKey = 'sort';
      sortBlock.hidden = false;
      sortBlock.removeAttribute('aria-hidden');
      if (availability && availability !== sortBlock && availability.nextElementSibling !== sortBlock) availability.insertAdjacentElement('afterend', sortBlock);
      sortSelect.setAttribute('aria-label', sortSelect.getAttribute('aria-label') || 'Sort products');
    }
  };

  const normalizeFilters = (scope = document) => {
    const forms = new Set([...(scope.querySelectorAll?.('.premium-page-filter__form, .premium-mobile-filter-drawer__form, [data-premium-mobile-filter-form]') || [])]);
    forms.forEach(normalizeFilterForm);
  };

  const initializeVariantSlideshow = (scope = document) => {
    const dataNodes = scope.querySelectorAll?.('[data-sq-collection-detail-slides]') || [];
    dataNodes.forEach((dataNode) => {
      if (dataNode.dataset.sqSlideshowInitialized === 'true') return;
      dataNode.dataset.sqSlideshowInitialized = 'true';
      let slides = [];
      try { slides = JSON.parse(dataNode.textContent || '[]'); } catch (_) { return; }
      slides = slides.filter((slide, index, array) => slide?.src && array.findIndex((candidate) => candidate.src === slide.src) === index).slice(0, 3);
      if (slides.length < 2) return;
      const section = dataNode.closest('.shopify-section') || document;
      const link = section.querySelector('.sq-story__detail-image');
      const image = link?.querySelector('img');
      if (!link || !image) return;
      link.classList.add('is-sq-variant-slideshow');
      slides.forEach((slide) => { const preload = new Image(); preload.src = slide.src; });
      let index = Math.max(0, slides.findIndex((slide) => image.currentSrc.includes(slide.src.split('?')[0]) || image.src.includes(slide.src.split('?')[0])));
      let paused = false;
      let timer = 0;
      const show = (nextIndex) => {
        index = nextIndex % slides.length;
        const slide = slides[index];
        image.classList.add('is-sq-changing');
        window.setTimeout(() => {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = slide.src;
          image.alt = slide.alt || image.alt;
          requestAnimationFrame(() => image.classList.remove('is-sq-changing'));
        }, 170);
      };
      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => { if (!paused && !document.hidden) show(index + 1); }, 3200);
      };
      link.addEventListener('mouseenter', () => { paused = true; });
      link.addEventListener('mouseleave', () => { paused = false; });
      link.addEventListener('focusin', () => { paused = true; });
      link.addEventListener('focusout', () => { paused = false; });
      link.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      link.addEventListener('touchend', () => { paused = false; }, { passive: true });
      start();
    });
  };

  const replaceText = (root, replacements) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,template')) return NodeFilter.FILTER_REJECT;
        return node.nodeValue?.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const raw = node.nodeValue || '';
      const trimmed = raw.replace(/\s+/g, ' ').trim();
      const next = replacements.get(trimmed);
      if (!next) return;
      const leading = raw.match(/^\s*/)?.[0] || '';
      const trailing = raw.match(/\s*$/)?.[0] || '';
      node.nodeValue = `${leading}${next}${trailing}`;
    });
  };

  const productCopy = new Map([
    ['SEE IT LOVE IT MAKE IT YOURS', 'THE LOOK AROUND IT'],
    ['Complete your look today', 'Complete the feeling'],
    ['Pair it with styles that bring out your most confident look.', 'Pieces chosen to complement the mood without competing with it.']
  ]);
  const cartCopy = new Map([
    ['Continue the look', 'The Finishing Touch'],
    ['Complete the bag with one more piece.', 'One more piece can change the whole look.'],
    ['Selected around what is already in your bag—use it if it helps, skip it if your look is complete.', "A final layer of pieces selected around what’s already in your bag."],
    ['Related edit', 'Related collection'],
    ['Keep exploring', 'More from Serein Queen'],
    ['Not ready to stop yet?', 'Still in the mood to discover?'],
    ['Continue into a nearby edit or return to the full Serein Queen collection world.', 'Continue into a nearby collection or return to the full Serein Queen world.']
  ]);
  const favoritesCopy = new Map([
    ['Tap the heart on a product card to save it here.', 'Heart a piece and it returns here whenever you do.'],
    ['Search by a word from the product title, color, or collection.', 'Search your saved pieces by title, color, or collection.'],
    ['Everything you save in the Serein Queen store appears here in one place — ready to shop, compare, or buy.', 'Everything you heart returns here—ready to revisit, compare, or make yours.'],
    ['Continue shopping', 'Discover more'],
    ['A rotating mix of Serein Queen pieces you may want to save next.', 'More pieces that may belong in your wardrobe.']
  ]);
  const showcaseCopy = new Map([
    ['Refresh the Edit', 'Refresh the Look'],
    ['Always in the edit', 'Always in the Look'],
    ['Three polished anchors stay in place while the rest of the page changes around them.', 'Three polished anchors at the heart of Serein Essentials.'],
    ['Fresh This Visit', 'Freshest Visit'],
    ['A changing mix of coordinated sets, polished tops and pants, plus fresh Serein Essentials discoveries.', 'Coordinated looks, polished separates, and fresh discoveries for this moment.'],
    ['The Dress Edit', 'The Dress Look'],
    ['Mini, midi, maxi, and sleeve stories rotate together so the dress section feels newly styled each visit.', 'Dresses with enough presence to carry the moment.'],
    ['Dress edit', 'Dress look'],
    ['Coat edit', 'Coat story'],
    ['Blazer edit', 'Blazer story'],
    ['The collection edit', 'The collection'],
    ['Browse the full curated edit in its permanent manual order.', 'Every piece, gathered in one place.'],
    ['This visit has been individually curated for you.', 'A fresh selection for this visit.']
  ]);

  const polishShowcase = (root) => {
    if (!(root instanceof Element)) return;
    replaceText(root, showcaseCopy);
    root.querySelectorAll('p,span,div').forEach((el) => {
      const text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.startsWith('A changing selection drawn only from ')) {
        el.textContent = `A fresh perspective on ${root.dataset.collectionTitle || 'this collection'}.`;
      } else if (/^A fresh .+ edit is now showing\.$/.test(text)) {
        el.textContent = text.replace(' edit is now showing.', ' selection is now showing.');
      }
    });
    const refresh = root.querySelector('[data-sq-refresh]');
    if (refresh && refresh.dataset.sqCopyBound !== 'true') {
      refresh.dataset.sqCopyBound = 'true';
      refresh.addEventListener('click', () => queueMicrotask(() => polishShowcase(root)));
    }
  };

  const polishCustomerCopy = (scope = document) => {
    const path = location.pathname.toLowerCase();
    if (path.includes('/products/')) replaceText(scope, productCopy);
    if (path === '/cart' || path.startsWith('/cart/')) replaceText(scope, cartCopy);
    if (path === '/pages/favorites') replaceText(scope, favoritesCopy);
    (scope.querySelectorAll?.('[data-sq-showcase]') || []).forEach(polishShowcase);
  };

  const run = (scope = document) => {
    normalizePartnerFooter(scope);
    normalizeFilters(scope);
    initializeVariantSlideshow(scope);
    polishCustomerCopy(scope);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  else run(document);

  document.addEventListener('shopify:section:load', (event) => run(event.target));
  ['facets:updated', 'filter:update', 'product-grid:updated'].forEach((name) => document.addEventListener(name, () => run(document.getElementById('MainContent') || document)));
  window.addEventListener('pageshow', (event) => { if (event.persisted) run(document); });
})();
